module.exports = __webpack_public_path__ + "static/media/born.13e9caf8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/born.png
// module id = 854
// module chunks = 0